
export default {
  name: "ResetPassword",
  data() {
    return {
      step: 1,
      email: "",
      time: 0,
      showTips: false,
      tipsMsg: "",
      verificationCode: "",
      showKeyboard: true,
      pwd: "",
      confirmPwd: "",
      showSuccessPopup: false,
    };
  },
  created() {},
  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.email = "807288057@qq.com";
    }
  },
  watch: {
    verificationCode(value) {
      if (value.length >= 6) {
        this.$api.user
          .verificationCode({
            code: this.verificationCode,
            email: this.email,
          })
          .then((res) => {
            if (res.code == 200) {
              this.step++;
            } else {
              this.tipsMsg = res.message;
              this.showTips = true;
              this.verificationCode = "";
            }
          });
      }
    },
  },
  computed: {},
  methods: {
    onClickHeaderReturn() {
      if (this.step == 3) {
        this.pwd = "";
        this.confirmPwd = "";
        this.verificationCode = "";
        this.step = 1;
        return;
      } else if (this.step == 2) {
        this.verificationCode = "";
        this.step = 1;
        return;
      } else if (this.step == 1) {
        this.$router.go(-1);
        return;
      }
    },
    onClickConfirm() {
      if (this.$utils.isNullAndEmpty(this.email)) {
        this.tipsMsg = "E-mail cannot be empty.";
        this.showTips = true;
        return;
      }
      if (!this.$utils.isEmail(this.email)) {
        this.tipsMsg = "Please enter the correct E-mail.";
        this.showTips = true;
        return;
      }
      this.$api.user
        .sendEmail({
          email: this.email,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$toast({
              type: "success",
              duration: "1000",
              position: "middle",
              message: "send success.",
            });
            this.time = 60;
            this.countDown();
            this.step++;
          } else {
            this.tipsMsg = res.message;
            this.showTips = true;
          }
        });
    },
    countDown() {
      this.time = 60;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    onClickReset() {
      if (this.$utils.isNullAndEmpty(this.pwd)) {
        this.tipsMsg = "New password cannot be empty.";
        this.showTips = true;
        return;
      }
      if (this.$utils.isNullAndEmpty(this.confirmPwd)) {
        this.tipsMsg = "Confirm password password cannot be empty.";
        this.showTips = true;
        return;
      }
      if (this.pwd.length < 6) {
        this.tipsMsg = "New password length cannot be less than 6 digits.";
        this.showTips = true;
        return;
      }
      if (this.confirmPwd.length < 6) {
        this.tipsMsg = "Confirm password length cannot be less than 6 digits.";
        this.showTips = true;
        return;
      }
      if (this.pwd != this.confirmPwd) {
        this.tipsMsg = "The two entered passwords do not match.";
        this.showTips = true;
        return;
      }
      this.$api.user
        .retrievePassword({
          code: this.verificationCode,
          email: this.email,
          password: this.pwd,
        })
        .then((res) => {
          if (res.code == 200) {
            this.showSuccessPopup = true;
          } else {
            this.tipsMsg = res.message;
            this.showTips = true;
          }
        });
    },
    onClickTipsOK() {
      this.showTips = false;
    },
    onClickLogin() {
      this.$router.go(-1);
    },
  },
};
